import {createUseStyles} from "react-jss";
import {colors} from "constants/colors";

const styles = createUseStyles({
  loyaltyBadge: {
    width: '100%',
    margin: "0px",
    '& .card-header, & .card-body, & .card-footer': {
      padding: "20px 24px"
    },
    "& .card-header, & .card-footer": {
      borderColor: colors.lightGrey,
      backgroundColor: "transparent"
    },
    borderColor: colors.lightGrey
  },
  loyaltyBadgeHeader: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column'
  },
  loyaltyBadgeBody: {
    flex: 'unset',
  },
  loyaltyBadgeTitle: {
    margin: 0,
    fontSize: 18,
    fontWeight: '600',
    lineHeight: '28px',
    color: colors.lightBlack
  },
  loyaltyBadgeSubtitle: {
    margin: 0,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '20px',
    color: colors.mediumGrey,
    '.disabled &': {
      color: colors.error600,
    }
  },
  loyaltyBadgeButton: {
    display: 'flex',
    justifyContent: 'end'
  },
  loyaltyBadgeNoBorder: {
    borderTop: "none",
    padding: "0 !important"
  }
});

export default styles;
